@if ((authenticationStep$ | async) === steps.login) {
  <app-authentication-home-step
    [userJourneyType]="resolveUserJourneyType()"
    [previewSubStep]="previewSubStep"
    [loginStepHeading]="loginStepHeading"
    [firstStepHeading]="firstStepHeading"
    [firstStepLoginButton]="firstStepLoginButton"
    [firstStepSignupButton]="firstStepSignupButton"
    [authenticationProviderGoogle]="authenticationProviderGoogle"
    [authenticationProviderFacebook]="authenticationProviderFacebook"
    [authenticationProviderApple]="authenticationProviderApple"
  ></app-authentication-home-step>
}
@if ((authenticationStep$ | async) === steps.signup) {
  <app-authentication-signup-step
    [userJourneyType]="resolveUserJourneyType()"
    [legalCheckboxLabel]="legalCheckboxLabel"
    [optinCheckboxLabel]="optinCheckboxLabel"
    [signupStepHeading]="signupStepHeading"
    [signupStepSubheading]="signupStepSubheading"
    [signupStepDisplayFirstname]="signupStepDisplayFirstname"
    [signupStepFirstnameLabel]="signupStepFirstnameLabel"
    [signupStepFirstnameHelp]="signupStepFirstnameHelp"
    [signupStepDisplayLastname]="signupStepDisplayLastname"
    [signupStepLastnameLabel]="signupStepLastnameLabel"
    [signupStepLastnameHelp]="signupStepLastnameHelp"
    [signupStepEmailLabel]="signupStepEmailLabel"
    [signupStepEmailHelp]="signupStepEmailHelp"
    [signupStepDisplayPhone]="signupStepDisplayPhone"
    [signupStepPhoneLabel]="signupStepPhoneLabel"
    [signupStepPhoneHelp]="signupStepPhoneHelp"
    [signupStepPasswordLabel]="signupStepPasswordLabel"
    [signupStepPasswordHelp]="signupStepPasswordHelp"
    [signupFooter]="signupFooter"
    [cgvUrl]="cgvUrl"
    [privacyPolicyUrl]="privacyPolicyUrl"
    [legalNoticeUrl]="legalNoticeUrl"
  ></app-authentication-signup-step>
}
